import { IPromise } from 'angular'
import { ApiResponse } from '@vend/types'

import { extractData } from '../../../util/extract-data'
import { $http } from '../../../ng-compat/imports'

const USERS_END_POINT = '/api/2.0/users'
const USER_ATTRIBUTES_END_POINT = '/api/2.0/user_attributes'

interface UserAttribute {
  id: string
  user_id: string
  name: string
  value: string
}

interface UserSales {
  label: string
  date_from: string
  date_to: string
  total: number
  cost: number
  tax: number
  revenue: number
  discounts: number
  loyalty: number
  sale_count: number
}

/**
 * Functions for querying the API for user data.
 */

/**
 * Get the current logged in user's sales for the day and the month.
 *
 * @param  userId
 *         The currently logged in user id.
 *
 * @return A promise resolved with the user sale data.
 */
export function getUserSales(userId: string): IPromise<UserSales[]> {
  return $http
    .get<ApiResponse<UserSales[]>>(`${USERS_END_POINT}/${userId}/sale_totals`)
    .then(extractData)
}

/**
 * Get user attributes for the provided UserId
 *
 * @param  userId
 *
 * @return A promise resolved with the new array of user attributes.
 */
export function getUserAttributes(userId: string): IPromise<UserAttribute[]> {
  return $http
    .get<ApiResponse<UserAttribute[]>>(
      `${USERS_END_POINT}/${userId}/attributes`
    )
    .then(extractData)
}

/**
 * Set a user attribute
 *
 * @param params
 *
 *          @param  user_id
 *                  The id of the user
 *
 *          @param  name
 *                  The name of the attribute to update
 *
 *          @param  value
 *                  The value of the attribute
 *
 * @return A promise resolved with the new array of user attributes.
 */
export function setUserAttribute(params: {
  user_id: string
  name: string
  value: string
}): IPromise<UserAttribute> {
  return $http
    .post<ApiResponse<UserAttribute>>(USER_ATTRIBUTES_END_POINT, params)
    .then(extractData)
}
